import { render, staticRenderFns } from "./waste.vue?vue&type=template&id=ae06226e&scoped=true&"
import script from "./waste.vue?vue&type=script&lang=js&"
export * from "./waste.vue?vue&type=script&lang=js&"
import style0 from "./waste.vue?vue&type=style&index=0&id=ae06226e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae06226e",
  null
  
)

export default component.exports